import * as React from 'react';
import { useUIFacade } from '../../../../../ui/facades/ui.facade';
import TrueFalseTemplate from '../../../../../ui/templates/columns/TrueFalseTemplate';
import ValueTemplate from '../../../../../ui/templates/columns/ValueTemplate';
import PrwcDataTableAdvanced from '../../../../../ui/widgets/custom/PrwcDataTableAdvanced';


const ShiftMappingList = (props: any) => {
  const { onEdit } = props;
  const uiFacade = useUIFacade();

  const handleOnDelete = (rowData: any) => {
    uiFacade.showConfirmDeleteDialog(rowData, deleteShiftMapping);
  }

  const deleteShiftMapping = (rowData: any) => {
    console.log('delete group --');
    console.log(rowData);
  }

  const editShiftMapping = (rowData: any) => {
    console.log('edit group ---');
    console.log(rowData);
    onEdit(rowData);
  }

  const data = [
    {
      firstHalfShiftCode: "WO",
      secondHalfShiftCode: "AB",
      fullDayShiftCode: "WO",
      displayShiftTime: true,
      rosterDisplayCode: "WO",
      shiftCategory: "Present"
    },
    {
      firstHalfShiftCode: "PL",
      secondHalfShiftCode: "APL",
      fullDayShiftCode: "WO",
      displayShiftTime: false,
      rosterDisplayCode: "WO",
      shiftCategory: "Absent"
    },
    {
      firstHalfShiftCode: "AB",
      secondHalfShiftCode: "EPTO",
      fullDayShiftCode: "WO",
      displayShiftTime: false,
      rosterDisplayCode: "WO",
      shiftCategory: "Present"
    },
    {
      firstHalfShiftCode: "WO",
      secondHalfShiftCode: "AB",
      fullDayShiftCode: "WO",
      displayShiftTime: true,
      rosterDisplayCode: "WO",
      shiftCategory: "Present"
    },
    {
      firstHalfShiftCode: "PL",
      secondHalfShiftCode: "APL",
      fullDayShiftCode: "WO",
      displayShiftTime: false,
      rosterDisplayCode: "WO",
      shiftCategory: "Absent"
    },
    {
      firstHalfShiftCode: "AB",
      secondHalfShiftCode: "EPTO",
      fullDayShiftCode: "WO",
      displayShiftTime: false,
      rosterDisplayCode: "WO",
      shiftCategory: "Present"
    }, 
    {
      firstHalfShiftCode: "WO",
      secondHalfShiftCode: "AB",
      fullDayShiftCode: "WO",
      displayShiftTime: true,
      rosterDisplayCode: "WO",
      shiftCategory: "Present"
    },
    {
      firstHalfShiftCode: "PL",
      secondHalfShiftCode: "APL",
      fullDayShiftCode: "WO",
      displayShiftTime: false,
      rosterDisplayCode: "WO",
      shiftCategory: "Absent"
    },
    {
      firstHalfShiftCode: "AB",
      secondHalfShiftCode: "EPTO",
      fullDayShiftCode: "WO",
      displayShiftTime: false,
      rosterDisplayCode: "WO",
      shiftCategory: "Present"
    }, 
    {
      firstHalfShiftCode: "WO",
      secondHalfShiftCode: "AB",
      fullDayShiftCode: "WO",
      displayShiftTime: true,
      rosterDisplayCode: "WO",
      shiftCategory: "Present"
    },
    {
      firstHalfShiftCode: "PL",
      secondHalfShiftCode: "APL",
      fullDayShiftCode: "WO",
      displayShiftTime: false,
      rosterDisplayCode: "WO",
      shiftCategory: "Absent"
    },
    {
      firstHalfShiftCode: "AB",
      secondHalfShiftCode: "EPTO",
      fullDayShiftCode: "WO",
      displayShiftTime: false,
      rosterDisplayCode: "WO",
      shiftCategory: "Present"
    }, 
    {
      firstHalfShiftCode: "WO",
      secondHalfShiftCode: "AB",
      fullDayShiftCode: "WO",
      displayShiftTime: true,
      rosterDisplayCode: "WO",
      shiftCategory: "Present"
    },
    {
      firstHalfShiftCode: "PL",
      secondHalfShiftCode: "APL",
      fullDayShiftCode: "WO",
      displayShiftTime: false,
      rosterDisplayCode: "WO",
      shiftCategory: "Absent"
    },
    {
      firstHalfShiftCode: "AB",
      secondHalfShiftCode: "EPTO",
      fullDayShiftCode: "WO",
      displayShiftTime: false,
      rosterDisplayCode: "WO",
      shiftCategory: "Present"
    }, 
  ];

  const dataTable = {
    columns: [
      {
        field: "firstHalfShiftCode",
        headerLabelKey: "shiftDetails.label.firstHalfShiftCode",
        bodyTemplate: ValueTemplate,
        className: "w-16 text-xs",
        sortable: true,
      },
      {
        field: "secondHalfShiftCode",
        headerLabelKey: "shiftDetails.label.secondHalfShiftCode",
        bodyTemplate: ValueTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "fullDayShiftCode",
        headerLabelKey: "shiftDetails.label.fullDayShiftCode",
        bodyTemplate: ValueTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "displayShiftTime",
        headerLabelKey: "shiftDetails.label.displayShiftTime",
        bodyTemplate: TrueFalseTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "rosterDisplayCode",
        headerLabelKey: "shiftDetails.label.rosterDisplayCode",
        bodyTemplate: ValueTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "shiftCategory",
        headerLabelKey: "shiftDetails.label.shiftCategory",
        bodyTemplate: ValueTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
    ],
  };

  return (
    <div>
      <PrwcDataTableAdvanced
        data={data}
        columns={dataTable.columns}
        paginator={true}
        onEdit={editShiftMapping}
        onDelete={handleOnDelete}
      ></PrwcDataTableAdvanced>
    </div>
  );
};

export default ShiftMappingList;
